import { ReactNode } from 'react';

import styles from './Field.module.css';

// Поле формы: подпись + произвольный контрол.
// sic! Не <label>: он неявно связывается с первым labelable-потомком, и при
// группе кнопок (SegmentedControl) ховер/клик по любому месту поля срабатывал
// бы на первой кнопке.
export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className={styles.field}>
      <span className={styles.field__label}>{label}</span>
      {children}
    </div>
  );
}
